import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NotFoundContainer = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const NotFoundContent = styled.div`
  text-align: center;
  max-width: 600px;
`;

const NotFoundIcon = styled.div`
  font-size: 120px;
  color: #ff6b35;
  margin-bottom: 30px;
  line-height: 1;
`;

const NotFoundTitle = styled.h1`
  font-size: 48px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const NotFoundMessage = styled.p`
  font-size: 18px;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const HomeButton = styled(Link)`
  display: inline-block;
  background: #ff6b35;
  color: white;
  padding: 15px 40px;
  border-radius: 30px;
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
  
  &:hover {
    background: #d95a1a;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
  }
  
  @media (max-width: 768px) {
    padding: 12px 30px;
    font-size: 16px;
  }
`;

const HelpfulLinks = styled.div`
  margin-top: 50px;
  padding-top: 30px;
  border-top: 1px solid #e0e0e0;
`;

const HelpfulLinksTitle = styled.h3`
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
`;

const LinksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
`;

const HelpfulLink = styled(Link)`
  color: #ff6b35;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 16px;
  border: 1px solid #ff6b35;
  border-radius: 20px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #ff6b35;
    color: white;
  }
`;

const NotFound = () => {
  return (
    <NotFoundContainer>
      <NotFoundContent>
        <NotFoundIcon>404</NotFoundIcon>
        <NotFoundTitle>Страница не найдена</NotFoundTitle>
        <NotFoundMessage>
          К сожалению, запрашиваемая страница не существует или была перемещена.
          <br />
          Возможно, вы ввели неправильный адрес или страница была удалена.
        </NotFoundMessage>
        <HomeButton to="/">
          Вернуться на главную
        </HomeButton>
        <HelpfulLinks>
          <HelpfulLinksTitle>Полезные ссылки:</HelpfulLinksTitle>
          <LinksList>
            <HelpfulLink to="/catalog">Каталог</HelpfulLink>
            <HelpfulLink to="/about">О нас</HelpfulLink>
            <HelpfulLink to="/contacts">Контакты</HelpfulLink>
            <HelpfulLink to="/delivery">Доставка</HelpfulLink>
          </LinksList>
        </HelpfulLinks>
      </NotFoundContent>
    </NotFoundContainer>
  );
};

export default NotFound;

